import { render, staticRenderFns } from "./AI-Personal-Center.vue?vue&type=template&id=4517d9a6&scoped=true&"
import script from "./AI-Personal-Center.vue?vue&type=script&lang=js&"
export * from "./AI-Personal-Center.vue?vue&type=script&lang=js&"
import style0 from "./AI-Personal-Center.vue?vue&type=style&index=0&id=4517d9a6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4517d9a6",
  null
  
)

export default component.exports